export enum Widths {
    tablet = 768,
    smallScreen = 1024,
}

export const date = 'dd.mm.yyyy';
export const dateTime = 'dd.mm.yyyy HH:MM:ss';
